import React from "react";
import style from "./style.module.scss";
import useDomainStore from "../../stores/domain";

const Checkbox = ({ value, onChange, checked = false, ...props }) => {
  const { isKurvDomain } = useDomainStore();
  return (
    <label className={style.container}>
      <input
        type="checkbox"
        className={style.input}
        value={value}
        onChange={onChange}
        checked={checked}
        {...props}
      />

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={style.checkmark}
      >
        <rect width="16" height="16" rx="4" fill={isKurvDomain ? "#22A276" : "#4C70EF"} />
        <path
          d="M4.75 8.91277L6.58768 10.8122L11.25 6.1499"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={style.un_checkmark}
      >
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="3.5"
          stroke="#A4A3A8"
        />
      </svg>
    </label>
  );
};

export default Checkbox;
